import { NgModule } from '@angular/core';

import { TextAreaDirective } from '~/directives/textarea/textarea';
import { AfterIfDirective } from '~/directives/events/afterIf';

@NgModule({
    declarations: [
        TextAreaDirective,
        AfterIfDirective,
    ],
    exports: [
        TextAreaDirective,
        AfterIfDirective,
    ]
})

export class AppDirectivesModule {
}
